import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthUser, useIsAuthenticated } from '../hooks/useAuth';

interface RedirectIfAuthProps {
  children: ReactNode;
  /** Cible de redirection (par défaut : `/`). */
  to?: string;
}

/**
 * Wrapper pour les pages d'authentification (login/register/2fa/forgot).
 * Si l'utilisateur est déjà authentifié, on le renvoie ailleurs.
 */
export const RedirectIfAuth = ({ children, to = '/' }: RedirectIfAuthProps) => {
  const isAuthenticated = useIsAuthenticated();
  const user = useAuthUser();

  if (isAuthenticated && user) {
    const isAdmin = (user.roles ?? []).includes('ADMIN');
    return <Navigate to={isAdmin ? '/admin/overview' : to} replace />;
  }

  return <>{children}</>;
};
